import {Button} from '@blesk-frontend/ui';
import React from 'react';
import {TPlatformType} from '@/libs';

interface GuideZeroCardProps {
  platformType: TPlatformType;
  icon: React.ReactNode;
  title: string;
  paragraph: string;
  buttonName: string;
  additionalInfo: string;
  onClickDownload: (platformType: TPlatformType) => void;
  disabledButton?: boolean;
}
export const GuideZeroCard = ({
  platformType,
  icon,
  title,
  paragraph,
  buttonName,
  additionalInfo,
  onClickDownload,
  disabledButton = false,
}: GuideZeroCardProps) => {
  return (
    <div className="flex max-w-md flex-col items-center gap-4 border p-5">
      {icon}
      <h2 className="text-center text-title-h2">{title}</h2>
      <p className="max-w-xl whitespace-pre-line text-center text-paragraph-sm text-text-secondary">
        {paragraph}
      </p>
      <Button onClick={() => onClickDownload(platformType)} disabled={disabledButton}>
        {buttonName}
      </Button>
      <p className="max-w-xl text-center text-paragraph-sm text-text-secondary">{additionalInfo}</p>
    </div>
  );
};
